import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import MiembrosComite from './MiembrosComite';
import * as yup from 'yup';
import es from '../../../../yup-es';
import { Button, Container, Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { fetchRolComite } from '../gestionConcursoSlice';
import { CONCURSOAPI } from '../../../../const';
import axios from 'axios';
import ErrorMsg from '../../../../components/CompUtils/ErrorMsg';
import { useHistory } from 'react-router';
import { finEtapa } from '../gestionConcursoSlice';
import { finalize, init } from '../../../../components/GlobalFeedback/feedbackSlice';
import { AlertaDialog } from '../../../../components/CompUtils/Alerta';

yup.setLocale(es);

export const ComiteContext = React.createContext();

const CargaConvocatoria = ({ concurso }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [alert, setAlert] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const [comite, setComite] = useState({ usuarios: {} });

  const onConfirmar = (values) => {
    dispatch(init());
    //Acomodo la estructura de usuarios del comité para que coincida con el backend
    const usuarios = Object.keys(comite.usuarios).reduce((acum, curKey) => {
      acum[curKey] = comite.usuarios[curKey].reduce((rolesAcum, rol) => {
        return [
          ...rolesAcum,
          {
            idUsuario: rol.usuario.idUsuario,
            titular: rol.usuario.titular,
            representacion: rol.usuario.representacion,
          },
        ];
      }, []);

      return acum;
    }, {});

    const formData = {
      idLlamadoConcurso: concurso.idLlamadoConcurso,
      nroTrataAsignacionConvocatoria: values.nroTrata,
      usuarios,
    };

    setErrorMsg('');
    axios
      .post(`${CONCURSOAPI}/llamadoconcurso/asignacioncomite/`, formData)
      .then((res) => {
        dispatch(finalize());
        setAlert(true);
      })
      .catch((error) => {
        dispatch(finalize());
        setErrorMsg(error.response.data || 'Error al intentar conectarse al servidor.');
      });
  };

  const finalizarConfirmacion = () => {
    setAlert(false);
    history.push('/concursos');
    dispatch(finEtapa());
  };

  const contextValue = { comite, setComite };
  useEffect(() => {
    dispatch(fetchRolComite());
  }, []);

  return (
    <>
      <Container fluid>
        <h3 className="text-center">Carga de Convocatoria</h3>
        <div className="mt-2 d-flex justify-content-center">
          <CargaConvocatoriaForm onSubmit={(values) => onConfirmar(values)} />
        </div>
        <br />
        <ComiteContext.Provider value={contextValue}>
          <MiembrosComite />
        </ComiteContext.Provider>
        {errorMsg && <ErrorMsg msg={errorMsg} />}
        <br />
        <Button variant="success" type="submit" form="formCargaConvocatoria">
          Confirmar
        </Button>
      </Container>

      <AlertaDialog size="sm" show={alert} onClose={finalizarConfirmacion} closeText="Cerrar">
        <div className="text-center">
          <i
            className="text-success fa fa-check-circle-o"
            style={{ fontSize: 64, WebkitTextStroke: '5px white' }}></i>
          <p>La información ha sido enviada al Director Concursal</p>
        </div>
      </AlertaDialog>
    </>
  );
};

export const CargaConvocatoriaForm = ({ onSubmit = null }) => {
  const handleSubmit = (values, actions) => {
    onSubmit && onSubmit(values);
  };
  const schema = yup.object({
    nroTrata: yup.string().required(),
  });
  const initial = {
    nroTrata: '',
  };

  return (
    <Formik
      validationSchema={schema}
      validateOnChange={false}
      initialValues={initial}
      onSubmit={handleSubmit}>
      {(formik) => (
        <Form inline noValidate onSubmit={formik.handleSubmit} id="formCargaConvocatoria">
          <Form.Group>
            <Form.Label>Nro expediente:&nbsp;</Form.Label>
            {/* <Form.Label>Nro 2do expediente:&nbsp;</Form.Label> */}
            <Form.Control
              className="mr-sm-2"
              name="nroTrata"
              value={formik.values.nroTrata}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              isInvalid={formik.touched.nroTrata && !!formik.errors.nroTrata}
            />
          </Form.Group>
        </Form>
      )}
    </Formik>
  );
};
export default CargaConvocatoria;
